var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14.5,
    fill: "white",
    stroke: "#F1F3FA",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8029 20.1825C12.5469 20.1825 12.2909 20.0851 12.0962 19.8891C11.7056 19.4985 11.7056 18.8665 12.0962 18.4758L18.4856 12.0865C18.8762 11.6958 19.5082 11.6958 19.8989 12.0865C20.2896 12.4771 20.2896 13.1091 19.8989 13.4998L13.5096 19.8891C13.3149 20.0851 13.0589 20.1825 12.8029 20.1825Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1951 20.1862C18.9391 20.1862 18.6831 20.0889 18.4884 19.8929L12.0938 13.4969C11.7031 13.1062 11.7031 12.4742 12.0938 12.0835C12.4858 11.6929 13.1178 11.6929 13.5071 12.0835L19.9018 18.4795C20.2924 18.8702 20.2924 19.5022 19.9018 19.8929C19.7071 20.0889 19.4498 20.1862 19.1951 20.1862Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseBorder);
export default __webpack_public_path__ + "static/media/iconCloseBorder.723d911a8a2654c2b05d4493586d6e15.svg";
export { ForwardRef as ReactComponent };